// @flow

export const measurementSystem = {
  metric: 'METRIC',
  imperial: 'IMPERIAL',
};

export type MeasurementSystem = $Values<typeof measurementSystem>;
